import React from 'react';
import moment from "moment-jalaali";


class Clock extends React.Component {
    state = {
        date:moment().locale('fa').format('jYYYY/jM/jD'),
        time:moment().locale('fa').format('HH:mm:ss')
    };
    componentDidMount(){
        this.interval = setInterval(() => {
            this.displayTime();
        }, 1000);
    }
    displayTime(){
        this.setState({
            time: moment().locale('fa').format('HH:mm:ss')
        });
    }
    render(){
        let {time,date} = this.state;
        return (
            <div className="text-center">
                {time}<br />
                {date}
            </div>
        );
    }
}
export default Clock;